import { ADD_AS, ADD_RI, ADD_RG, ADD_IG, ADD_UC, ADD_PRODUCTOS_FLAG_CANCELAR } from "./actions";

const initialState = {
  AS: {},
  RI: {},
  RG: {},
  IG: {},
  UC: {},
  productosFlagCancelar: ["IG", "UC"],
};

const configReducer = (state = initialState, action) => {
  const { type, AS, RI, RG, IG, UC, productosFlagCancelar } = action;

  switch (type) {
    case ADD_AS:
      return { ...state, AS };
    case ADD_RI:
      return { ...state, RI };
    case ADD_RG:
      return { ...state, RG };
    case ADD_IG:
      return { ...state, IG };
    case ADD_UC:
      return { ...state, UC };
    case ADD_PRODUCTOS_FLAG_CANCELAR:
      return { ...state, productosFlagCancelar };
    default:
      return state;
  }
};

export default configReducer;
